import { HeaderThree } from 'secondstep-components'
import PropTypes from 'prop-types'
import ProgramLinkTile from 'components/dashboard/ProgramLinkTile'
import { StyledTilesContainer } from './component.styles'
import { SUBHEADER_TEXT } from './constants'

function Component(props) {
  const {
    sortedTeachLinks,
    displayTitle,
    headerDataTestId,
    staticLinksAvailable,
  } = props
  return (
    sortedTeachLinks?.length > 0 && [
      <HeaderThree
        className="program-subheader"
        dataTestId={headerDataTestId}
        key={`subheader-${displayTitle}`}
      >
        {SUBHEADER_TEXT}
      </HeaderThree>,
      <StyledTilesContainer key="high-school-pathways-teach-links">
        {sortedTeachLinks
          .filter(({ displayTitle, path } = {}) => !!displayTitle && !!path)
          .map(({ displayTitle, path } = {}) => (
            <ProgramLinkTile
              displayTitle={displayTitle}
              isPreview
              key={`${displayTitle}-program-link`}
              path={path}
            />
          ))}
      </StyledTilesContainer>,
      <StyledTilesContainer key="high-school-pathways-static-links">
        {staticLinksAvailable
          .filter(
            ({ displayTitle, linkLabel, path } = {}) =>
              !!displayTitle && !!linkLabel && !!path,
          )
          .map(({ displayTitle, linkLabel, path }) => (
            <ProgramLinkTile
              displayTitle={displayTitle}
              key={`${displayTitle}-program-link`}
              linkLabel={linkLabel}
              path={path}
              secondary
            />
          ))}
      </StyledTilesContainer>,
    ]
  )
}

Component.propTypes = {
  activeTabProgramsAvailable: PropTypes.array,
  displayTitle: PropTypes.string,
  headerDataTestId: PropTypes.string,
  sortedTeachLinks: PropTypes.array,
  staticLinksAvailable: PropTypes.array,
}

Component.displayName = 'Preview'

export default Component
